import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-checkbox-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  template: `
    <div class="field-wrapper" [class.has-error]="isInvalid">
      <div class="checkbox-label-row">
        <label>
          <input type="checkbox" [formControl]="control" />
          {{ field.label }}
        </label>
        <a *ngIf="hasLabelLink"
           [href]="field.linkUrl"
           [target]="field.linkTarget ?? '_blank'"
           [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null"
           class="field-label-link">{{ field.linkText }}</a>
      </div>
      <small *ngIf="field.hint && !isInvalid"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>
      <small *ngIf="isInvalid" class="error">{{ errorMessage }}</small>
    </div>
  `,
  styles: [`
    .checkbox-label-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px;
    }
  `]
})
export class CheckboxFieldComponent extends BaseFieldComponent {}